import { useQuery } from 'react-query';

import { getStoryImage as queryFn } from 'api/endPoints/getStoryImage';

export const useQueryGetStoryImage = (params) => {
    return useQuery<string, QueryError>(['getStoryImage', params], () => queryFn(params), {
        enabled: Boolean(params.id),
        cacheTime: 100000,
    });
};
